import { AbstractDataSourceType } from './../sources/abstract-data-source-type';

export abstract class DataSource {
    public data: AbstractDataSourceType[];

    constructor(elements: any[]) {
        this.init(elements as AbstractDataSourceType[]);
    }

    protected init(elements: AbstractDataSourceType[]) {
        let currentId = 0;
        elements.forEach((el) => {
            el._internal_datasource_id_ = currentId;
            currentId = currentId + 1;
        });
        this.data = elements;
    }
}
